import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {SimplePresentation} from "../../core/winpresentation/SimplePresentationRunner";
import {BruteForce} from "../BruteForce";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BruteForceSound} from "../sound/BruteForceSound";


export class BruteForceIdleNormalPresentation implements FlowStatePresentation {
    private _presentations: SimplePresentation[];
    private _controller: FlowStateController;
    private _tl: gsap.core.Timeline;
    private _idleTl: gsap.core.Timeline;
    private _machineTl: gsap.core.Timeline;

    constructor() {
        this._presentations = []
    }

    public start(flowStateController: FlowStateController) {
        this._controller = flowStateController;
        this._controller.setSkipCallback(() => {
            this.presentationComplete();
        });


        if (!BruteForce.model.gameData) {
            return;
        }

        if (BruteForce.autoPlayPlugin.isAutoplayRound) {
            return;
        }

        if (BruteForce.isActionSpinsActive) {
            return;
        }

        if (BruteForce.model.gameData?.betLineWins.length > 0) {
            // BruteForce.anticipationView.closeXBetHighlight();
            this.playBetlineTOggle(1.5);
        } else {
            if (BruteForce.model.nextMode.includes("NORMAL")) {
                BruteForce.anticipationView.updateXBetState();
            }

            if (!BruteForce.apiPlugin.isReplay) {
                if (BruteForce.model.nextMode.includes("NORMAL")) {
                    const reelData: string[][] = JSON.parse(JSON.stringify(BruteForce.model.reels));
                    for (let reelId: number = 0; reelId < reelData.length; reelId++) {
                        if (reelData[reelId].length > 5) {
                            reelData[reelId] = reelData[reelId].slice(1, reelData[reelId].length - 1);
                        }
                    }
                    BruteForce.allreelsView.reelModels.forEach((reel: SimpleReelModel, index: number) => {
                        if (!reelData[index].includes("XN")) {
                            reel.setInteractiveSymbols(true);
                        }
                    });
                }
            }

            if (BruteForce.model.nextMode.includes("NORMAL") && !BruteForce.autoPlayPlugin.isAutoplayRound) {
                BruteForce.foregroundElements.setInteractiveButton(true);
                this.playIdleAnimation();
            }

        }

    }

    private playBetlineTOggle(timeNeeded: number = 0.001): void {
        this._tl = gsap.timeline({
            onComplete: () => {
                this._tl.kill();
                this.playBetlineTOggle();
            }
        });
        this._tl.to(this, {duration: timeNeeded});
        this._tl.add(BruteForce.betlineView.showBetLine(true));
        this._tl.to(this, {duration: 0.3});
    }

    private playIdleAnimation() {
        if (this._tl !== undefined) {
            this._tl.kill();
        }
        this._tl = gsap.timeline({
            onComplete: () => {
                if (BruteForce.model.nextMode.includes("NORMAL")) {
                    this.playIdleAnimation();
                }
            }
        });
        this._tl.add(this.idleAnimation(), 0);

        const easterTl: gsap.core.Timeline = gsap.timeline({
                delay: 3, onComplete: () => {
                    easterTl.kill()
                }
            }
        );
        easterTl.add(() => {
            BruteForce.foregroundElements.buttonCountReset();
        });
        this._tl.add(easterTl, 0);
    }


    private machineidleAnimation(): gsap.core.Timeline {
        this._machineTl = gsap.timeline();
        const gamelogoTl: gsap.core.Timeline = gsap.timeline();

        gamelogoTl.add(() => {
            BruteForce.foregroundElements.playArcadeMachineAnimation("logo_brute", false, "logo_nolimitCity", false);
        }, 0);

        this._machineTl.add(gamelogoTl);
        return this._machineTl;
    }

    private idleAnimation(): gsap.core.Timeline {
        if (this._idleTl !== undefined) {
            this._idleTl.kill();
        }
        this._idleTl = gsap.timeline({delay: ArrayHelper.getRandomValue([3, 4, 5, 6, 7])});

        const reelRandomId: number = ArrayHelper.getRandomValue([0, 1, 2, 3, 4]);
        const symRandomPos: number = ArrayHelper.getRandomValue([0, 1, 2, 3, 4]);
        let randomSym: BruteForceSymbol;

        randomSym = <BruteForceSymbol>BruteForce.allreelsView.reelModels[reelRandomId].getStopSymbolAt(symRandomPos);
        if (randomSym.symbolName.includes("XN") || randomSym.symbolName.includes("M")) {
            this._idleTl.add(randomSym.setState(BruteForceSymbolStates.IDLE), 0);
            this._idleTl.add(randomSym.setState(BruteForceSymbolStates.NORMAL));
        } else {
            this._idleTl.add(this.machineidleAnimation());
        }
        return this._idleTl;
    }

    public presentationComplete(): void {
        BruteForce.betlineView.reset();
        if (this._machineTl !== undefined) {
            this._machineTl.kill();
        }
        if (this._idleTl !== undefined) {
            this._idleTl.kill();
        }
        if (this._tl !== undefined) {
            this._tl.totalProgress(1);
            this._tl.kill();
        }
        this.finish();
    }

    private finish(): void {
        BruteForce.allreelsView.reelModels.forEach((reelModel: SimpleReelModel, reelNo: number) => {
            reelModel.reelView.isReelContainingFullNudge = false;
            reelModel.reelView.nudgeReelPos = -2;
            reelModel.reelView.nudgeHeight = 0;

        });
        BruteForceGameConfig.isScatterAnticipationOnReelActive = [false, false, false, false, false];
        this._controller.finish();
    }
}